import { openMediaUploadPrompt } from 'proseShared/prompts/MediaUploadPrompt/MediaUploadPrompt'
import { EditorView } from 'prosemirror-view'
import { schema } from 'prose-core'
import { ImageNodeAttrs } from './Types'
import { replaceImageWithImages } from './utils'
import { IStackManager } from 'almanac-ui/Modal/Types'

type Options = Parameters<typeof openMediaUploadPrompt>[0]
export const openImageReplacePrompt = async (
  view: EditorView<typeof schema>,
  attrs: ImageNodeAttrs,
  options: Partial<Options> & { stackManager: IStackManager },
) => {
  const images = await openMediaUploadPrompt({
    ...options,
    view,
    multiSelect: true,
  })
  if (!images) return

  replaceImageWithImages(view, attrs, images)
}
